import { cls } from "@wss/cls";
import React, { ComponentProps } from "react";
import Category from "../Category";
const SkeletonContainer = ({
  className
}: ComponentProps<"div">) => {
  const emptyItem = {
    itemNumber: "",
    description: "",
    imagePath: "",
    link: "",
    altText: "",
    price: 0,
    salePrice: 0,
    displaySalePrice: false,
    unitOfMeasure: "",
    isWebstaurantPlusEligible: false
  };
  const skeletonItems = Array.from({
    length: 4
  }, (_, index) => [<Category key={`skeleton-${index}`} categoryName="" loading={true} items={Array.from({
    length: 4
  }, () => emptyItem)} />, `skeleton-${index}`]);
  return <div className={cls("relative", className)} data-testid="skeleton-container" data-sentry-component="SkeletonContainer" data-sentry-source-file="SkeletonContainer.tsx">
      <div className="overflow-hidden">
        <div className="flex flex-row space-x-4">
          {skeletonItems.map(([item]) => item)}
        </div>
      </div>
    </div>;
};
export default SkeletonContainer;